export default __webpack_public_path__ + "static/media/resume_hack_icon.674b5a0d.svg";